<mat-toolbar color="accent">Edit Due Date</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-row gap-4">
    <mat-form-field subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Due Date</mat-label>
      <input
        matInput
        [formControl]="dueDateCtrl"
        [matDatepicker]="dueDatePicker"
        [placeholder]="isDraft ? 'TBD' : ''"
        (focus)="dueDatePicker.open()"
        (click)="dueDatePicker.open()"
      />
      <mat-datepicker-toggle matIconSuffix [for]="dueDatePicker" />
      <mat-datepicker #dueDatePicker />
    </mat-form-field>

    <button
      type="button"
      mat-stroked-button
      (click)="resetToDefault()"
      [disabled]="isResetting"
    >
      Reset to Default
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="!isDraft && !dueDateCtrl.value"
      (click)="submit()"
    >
      Save
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
